module.exports = __webpack_public_path__ + "media/boost.6cec372a.mp4";